/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios"
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import { getBizID, getServices } from "../../libs/todoSlice"
import { getSharedTokenRedux, setSharedTokenRedux, getTaxIDRedux, setTaxIDRedux } from "../../libs/digitalWorkFlowSlice"



export default function DigitalWorkFlow() {
  const bizID = useSelector(getBizID)
  const params = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const services = useSelector(getServices)
  useEffect(() => {
    if (!services.includes('digital-workflow')) {
      navigate(`/${params.prefix}/manage-members`)
    }
  }, [services])

  // const sharedToken = useSelector(getSharedTokenRedux)
  // const setSharedToken = (action) => {
  //   dispatch(setSharedTokenRedux({
  //     sharedToken: action
  //   }))
  // }

  const [sharedToken, setSharedToken] = useState('')
  const [urlIframe, setUrlIframe] = useState('')

  const taxID = useSelector(getTaxIDRedux)
  const setTaxID = (action) => {
    dispatch(setTaxIDRedux({
      taxID: action
    }))
  }

  const getSharedToken = async () => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/shared-token`,
      })
      setSharedToken(data.data.shared_token)
    } catch ({ response }) {
      const { status } = response
      if (status === 401) {
        navigate(`/${params.prefix}`)
      }
    }
  }

  const getTaxID = async () => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/business/taxid?biz_id=${bizID}`,
      })
      setTaxID(data.data.tax_id)
    } catch ({ response }) {
      const { status } = response
      if (status === 401) {
        navigate(`/${params.prefix}`)
      }
    }
  }

  const getIframeURL = async () => {
    try {
      const { data } = await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/digital-work-flow/get-redirect-url`, 
        data: {
          domain_app: process.env.REACT_APP_ENV,
          biz_id: bizID
        },
        withCredentials: true, 
      })
      setUrlIframe(data.data.redirect_url)
    } catch ({ response }) {
      const { status } = response
      if (status === 401) {
        navigate(`/${params.prefix}`)
      }
    }
  }

  useEffect(() => {
    setSharedToken('')
    getSharedToken()
    getTaxID()
    getIframeURL()

  }, [params])

  if (process.env.REACT_APP_ENV === 'production') {

    return sharedToken && (
      <iframe
        src={`${urlIframe}${params.action ? `&redirect=${params.action}` : ''}`}
        frameborder="0"
        style={{
          width: '100%',
          height: '100vh'
        }}
        title="digital-workflow"
      />
    )
  } else {
    return (
      <iframe
        src={`${urlIframe}${params.action ? `&redirect=${params.action}` : ''}`}
        frameborder="0"
        style={{
          width: '100%',
          height: '100vh'
        }}
        title="digital-workflow"
      />
    )
  }
}